export default __webpack_public_path__ + "locales/bg/ChangePortalOwner.json?hash=6d8f82f6d5aa6080cf41ac06073bb99c";